import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const useKeepInTouchAccountNotesMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: () => void;
} = {}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: (notes: string) => {
			return userSession.webServiceHelper.callAsync<Api.IAccount>('account/preferences/keepInTouchNotes', 'PUT', notes);
		},
		onError,
		onSuccess,
	});
};
